//引入时间转化过滤器
import toTime from './toTime'
import rephtml from "./rephtml";
import timestamp from "./timestamp";
export default {
    toTime,
    rephtml,
    timestamp
}


// WEBPACK FOOTER //
// ./src/filter/index.js